"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDownIcon = exports.DropDownBox = exports.NavButton = exports.RestLinksDropDown = exports.RestLinksInline = exports.SubNavItem = exports.NavItem = exports.ColumnRight = exports.Column = exports.LogoWrapper = exports.Container = exports.Wrapper = exports.PhoneNumber = exports.StickyNavCta = exports.StickyNavPhoneLink = exports.NavigationWrapper = exports.NavListItem = exports.topNavLinkInverseStyle = exports.topNavLinkStyle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var topNavLinkStyle = (0, _styledComponents.css)(["", ";"], function (_ref) {
  var _ref$theme = _ref.theme,
    animation = _ref$theme.animation,
    topNav = _ref$theme.topNav.desktop;
  return (0, _styledComponents.css)(["font-size:", ";line-height:", ";font-weight:", ";color:", ";transition:", ";text-decoration:none;white-space:nowrap;"], topNav.fontSize, topNav.lineHeight, topNav.fontWeight, topNav.textColor, animation.transitionMedium);
});
exports.topNavLinkStyle = topNavLinkStyle;
var topNavLinkInverseStyle = (0, _styledComponents.css)(["", ";color:", ";"], topNavLinkStyle, function (_ref2) {
  var theme = _ref2.theme;
  return theme.topNav.desktop.textColorInverse;
});
exports.topNavLinkInverseStyle = topNavLinkInverseStyle;
var NavListItem = _styledComponents.default.li.withConfig({
  displayName: "TopNavstyle__NavListItem",
  componentId: "sc-1h2bs0c-0"
})(["padding:", ";display:flex;a,button{", ";", ";&:hover{opacity:0.8;}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.xs;
}, function (_ref4) {
  var isDark = _ref4.isDark;
  return isDark ? topNavLinkInverseStyle : topNavLinkStyle;
}, function (_ref5) {
  var small = _ref5.small;
  return small && (0, _styledComponents.css)(["font-size:", ";"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.topNav.desktop.fontSizeSmall;
  });
});
exports.NavListItem = NavListItem;
var NavigationWrapper = _styledComponents.default.div.withConfig({
  displayName: "TopNavstyle__NavigationWrapper",
  componentId: "sc-1h2bs0c-1"
})(["display:flex;align-items:center;"]);
exports.NavigationWrapper = NavigationWrapper;
var StickyNavPhoneLink = _styledComponents.default.a.withConfig({
  displayName: "TopNavstyle__StickyNavPhoneLink",
  componentId: "sc-1h2bs0c-2"
})(["display:flex;align-items:center;", " padding:", ";text-decoration:none;font-weight:", ";"], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.xs;
}), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.sm;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.bold;
});
exports.StickyNavPhoneLink = StickyNavPhoneLink;
var StickyNavCta = _styledComponents.default.div.withConfig({
  displayName: "TopNavstyle__StickyNavCta",
  componentId: "sc-1h2bs0c-3"
})(["padding:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.sm;
});
exports.StickyNavCta = StickyNavCta;
var PhoneNumber = _styledComponents.default.span.withConfig({
  displayName: "TopNavstyle__PhoneNumber",
  componentId: "sc-1h2bs0c-4"
})(["white-space:nowrap;font-weight:", ";", ""], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeightBold;
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-left: ", ";\n  "])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.xs;
}));
exports.PhoneNumber = PhoneNumber;
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "TopNavstyle__Wrapper",
  componentId: "sc-1h2bs0c-5"
})(["visibility:", ";@media (min-width:", "){padding:", " 0;}", ";"], function (_ref13) {
  var visibilityHidden = _ref13.visibilityHidden;
  return visibilityHidden ? 'hidden' : 'visible';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.md;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.sm;
}, function (_ref16) {
  var isSticky = _ref16.isSticky,
    stickyNavActive = _ref16.stickyNavActive,
    _ref16$theme = _ref16.theme,
    topNav = _ref16$theme.topNav.desktop,
    animation = _ref16$theme.animation,
    breakpoints = _ref16$theme.breakpoints;
  return isSticky && (0, _styledComponents.css)(["background:", ";position:fixed;top:0;left:0;right:0;width:100%;box-shadow:", ";will-change:transform,opacity;z-index:10;@media (min-width:", "){padding:", ";}", ""], topNav.stickyNavBackgroundColor, topNav.stickyNavBoxShadow, breakpoints.lg, topNav.stickyNavPadding, function () {
    var _animation$duration = animation.duration,
      mediumSlow = _animation$duration.mediumSlow,
      medium = _animation$duration.medium,
      fast = _animation$duration.fast,
      slow = _animation$duration.slow;
    var bezier = animation.cubicBezier.fastOutSlowIn;
    return stickyNavActive ? (0, _styledComponents.css)(["opacity:1;transform:translateY(0);pointer-events:auto;transition:opacity 0ms,transform ", "ms ", ";"], mediumSlow, bezier) : (0, _styledComponents.css)(["opacity:0;transform:translateY(-100%);pointer-events:none;transition:opacity ", "ms ", "ms ", ",transform ", "ms ", ";"], slow, fast, bezier, medium, bezier);
  });
});
exports.Wrapper = Wrapper;
var Container = _styledComponents.default.nav.withConfig({
  displayName: "TopNavstyle__Container",
  componentId: "sc-1h2bs0c-6"
})(["display:none;@media (min-width:", "){display:flex;justify-content:space-between;max-width:", ";margin:0 auto;}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.breakpoints.md;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.gridWidth;
});
exports.Container = Container;
var LogoWrapper = _styledComponents.default.div.withConfig({
  displayName: "TopNavstyle__LogoWrapper",
  componentId: "sc-1h2bs0c-7"
})(["display:flex;a{padding:", ";display:flex;span{align-items:center;}}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.xs;
});
exports.LogoWrapper = LogoWrapper;
var Column = _styledComponents.default.ul.withConfig({
  displayName: "TopNavstyle__Column",
  componentId: "sc-1h2bs0c-8"
})(["display:flex;align-items:center;"]);
exports.Column = Column;
var ColumnRight = (0, _styledComponents.default)(Column).withConfig({
  displayName: "TopNavstyle__ColumnRight",
  componentId: "sc-1h2bs0c-9"
})(["", ""], (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-left: auto;\n  "]))));
exports.ColumnRight = ColumnRight;
var NavItem = _styledComponents.default.li.withConfig({
  displayName: "TopNavstyle__NavItem",
  componentId: "sc-1h2bs0c-10"
})(["position:relative;", " padding-bottom:", ";margin-top:", ";display:flex;align-items:center;", ";@media (min-width:", "){", "}&:hover,&:focus,&:active,&.focus{ul,&::before{opacity:1;visibility:visible;pointer-events:auto;transform:translateY(0);}}> a,> button{", ";padding:", ";&:hover{opacity:0.8;}}"], (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.sm;
}), function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.xs;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.xs;
}, function (_ref23) {
  var noDropdown = _ref23.noDropdown;
  return !noDropdown && (0, _styledComponents.css)(["&::before{content:'';bottom:-1px;z-index:2;right:50%;position:absolute;width:10px;height:10px;border:10px solid rgba(255,255,255,0);border-bottom-color:white;transform-origin:center;outline:none;pointer-events:none;filter:drop-shadow( 0 -1px 0 ", " );opacity:0;visibility:hidden;transform:translateY(-", ");transition:all ", ";}"], function (_ref24) {
    var theme = _ref24.theme;
    return theme.topNav.desktop.dropDownBorderColor;
  }, function (_ref25) {
    var theme = _ref25.theme;
    return theme.space.sm;
  }, function (_ref26) {
    var theme = _ref26.theme;
    return theme.animation.transitionMedium;
  });
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.breakpoints.lg;
}, (0, _styledComponentsRtl.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      margin-left: ", ";\n    "])), function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.md;
}), function (_ref29) {
  var isDark = _ref29.isDark;
  return isDark ? topNavLinkInverseStyle : topNavLinkStyle;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.space.xs;
});
exports.NavItem = NavItem;
var SubNavItem = _styledComponents.default.li.withConfig({
  displayName: "TopNavstyle__SubNavItem",
  componentId: "sc-1h2bs0c-11"
})(["", " a,button{", ";padding:", " 0;display:block;&:not(:hover){opacity:0.8;}}button{cursor:pointer;width:100%;}"], (0, _styledComponentsRtl.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    text-align: left;\n  "]))), topNavLinkInverseStyle, function (_ref31) {
  var theme = _ref31.theme;
  return theme.space.xs;
});
exports.SubNavItem = SubNavItem;
var RestLinksInline = _styledComponents.default.ul.withConfig({
  displayName: "TopNavstyle__RestLinksInline",
  componentId: "sc-1h2bs0c-12"
})(["display:none;@media (min-width:", "){display:flex;}"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.breakpoints.xl;
});
exports.RestLinksInline = RestLinksInline;
var RestLinksDropDown = _styledComponents.default.ul.withConfig({
  displayName: "TopNavstyle__RestLinksDropDown",
  componentId: "sc-1h2bs0c-13"
})(["display:flex;@media (min-width:", "){display:none;}"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.breakpoints.xl;
});
exports.RestLinksDropDown = RestLinksDropDown;
var NavButton = _styledComponents.default.button.withConfig({
  displayName: "TopNavstyle__NavButton",
  componentId: "sc-1h2bs0c-14"
})(["", ";display:flex;align-items:center;position:relative;"], function (_ref34) {
  var isDark = _ref34.isDark;
  return isDark ? topNavLinkInverseStyle : topNavLinkStyle;
});
exports.NavButton = NavButton;
var DropDownBox = _styledComponents.default.ul.withConfig({
  displayName: "TopNavstyle__DropDownBox",
  componentId: "sc-1h2bs0c-15"
})(["", ""], function (_ref35) {
  var _ref35$theme = _ref35.theme,
    space = _ref35$theme.space,
    animation = _ref35$theme.animation,
    topNav = _ref35$theme.topNav.desktop;
  return (0, _styledComponents.css)(["background:", ";border-radius:", ";border:1px solid ", ";box-shadow:", ";padding:", ";position:absolute;top:100%;right:0;z-index:2;max-width:280px;pointer-events:none;opacity:0;visibility:hidden;transform:translateY(-", ");transition:all ", ";li{display:flex;}li a{flex-grow:1;width:100%;white-space:pre-wrap;@supports (width:max-content){width:max-content;}color:", ";&:hover,&:focus,&:active{color:", ";}}"], topNav.dropDownBackgroundColor, topNav.dropDownBorderRadius, topNav.dropDownBorderColor, topNav.dropDownBoxShadow, topNav.dropDownPadding, space.sm, animation.transitionMedium, topNav.dropDownTextColor, topNav.dropDownTextColorHover);
});
exports.DropDownBox = DropDownBox;
var DropDownIcon = _styledComponents.default.div.withConfig({
  displayName: "TopNavstyle__DropDownIcon",
  componentId: "sc-1h2bs0c-16"
})(["", ""], (0, _styledComponentsRtl.default)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n    padding-left: ", ";\n  "])), function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.xs;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.space.xs;
}));
exports.DropDownIcon = DropDownIcon;